export default __webpack_public_path__ + "static/media/sample_lead.8cb16a07.csv";